import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import translations from './translations';
import {getLang} from 'i18n/lang';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    keySeparator: '~',
    resources: translations,
    lng: getLang(),
    fallbackLng: "us",

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
